//Journals fields

import { useState ,useEffect} from "react";
import reload from "../../assets/icons/reload.svg";
import CustomTabsV2 from "../universal/CustomTabsV2";
import CollapsibleRightPanel from "../universal/CollapsibleRightPanel";
import close from "../../assets/icons/close.svg";
import Modal from "react-modal";
import { useLocation } from "react-router-dom";
import "react-datetime-picker/dist/DateTimePicker.css";
import "react-calendar/dist/Calendar.css";
import "react-clock/dist/Clock.css";
import ReactModal from "react-modal";
import { ImCross } from "react-icons/im";
import { BsPlus } from "react-icons/bs";
import { useDispatch } from "react-redux";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import {
  FaInfoCircle,
  FaMinusCircle,
  FaPlus,
  FaPlusCircle,
} from "react-icons/fa";
import UploadControlsV2 from "../TWG/UploadControlsV2";
import { JournalsHookNew } from "../../screens/Journals/hooks/JournalsHooksNew";
import { FaCheck } from "react-icons/fa6";
import { IoIosArrowBack, IoMdClose } from "react-icons/io";
import UploadVideoButton from "./UploadVideoButton";
import UploadImageButton from "./UploadImageButton";
import UploadAudioButton from "./ UploadAudioButton";
import { RiDeleteBin5Line } from "react-icons/ri";
import MyStatefulEditor from "../universal/MyStatefulEditor";
import AudioCard from "./AudioCard";
import NotePreviewCard from "./ NotePreviewCard";
import LoaderSpinner from "../universal/LoaderSpinner";
import { JOURNAL_NOTE_ITEM_TYPES } from "../../constants/Common";
import { MdDelete } from "react-icons/md";
import { FiPlusCircle } from "react-icons/fi";
import LanguageDrawer from "../universal/LanguageDrawer";
import { format } from "date-fns";
import { IoClose } from "react-icons/io5";
import { LuSearch } from "react-icons/lu";
import { useSelector } from "react-redux";
import {
    readJournalAction,
  } from "../../store/Languages/LanguageAction.js";

const AddJournalFields = ({ selectedJournals,setLoading,rowData, isLoading ,hideUI,onClose,reloadData,setReloadData,church}) => {
  const location = useLocation();
  const [journalId, setJournalId] = useState(location?.state?._id);
    const { userInfo } = useSelector((state) => state.user);
     const churches = useSelector((state) => state.churches.churches);
  useEffect(()=>{
    if(rowData){
        setJournalId(rowData?._id)
    }
  },[rowData])
  useEffect(() => {
    if (!selectedJournals || selectedJournals.length === 0) return;
    const selected = selectedJournals?.[0]; // because your data shows index 0
    setJournalId(selected?._id)

    setJournalValues(prev => ({
      ...prev,
      journal_title: selected?.journal_title || "",
      journal_description: selected?.journal_description || "",
      speakerObjId: selected?.speakerObjId || "",
      categoryObjId: selected?.categoryObjId || "",
      bg_Images: selected?.bg_Images?.length
        ? selected?.bg_Images
        : prev.bg_Images,
      banner_Images: selected?.banner_Images?.length
        ? selected?.banner_Images
        : prev.banner_Images,
      notes: selected?.notes || [],
    }));
  }, [selectedJournals]);

  const {
    journalValues,
    handleChange,
    handleChangeId,
    addNewNotes,
    currNotesIndex,
    currNotes,
    setCurrNotes,
    cancelNotes,
    saveNotes,
    saveNotesLanguage,
    setShowNotesBox,
    showNotesBox,
    setCurrNotesIndex,
    setIsNotesEdit,
    initialNotesState,
    cancelJournal,
    saveJournals,
    saveJournalsLanguage,
    journalsErrors,
    showJournalsErrors,
    setShowJournalsErrors,
    activeTab,
    setActiveTab,
    updateJournalsWithTranslation,
    updateNotesWithTranslation,
    setShowJournalBox,
    showJournalBox,
    handleDeleteNotes,
    activeLanguageDetails,
    journalStats,
    forceEditorUpdate,
    handleAddNotesAsset,
    handlePublishJournal,
    journalPublishLoading,
    deleteNoteItem,
    handleAddNoteText,
    setIsLanguageSave,
    speakers,
    journalCategoriesList,
    activeSpeakerDetails,
    activeCategoryDetails,
    readLanguageData,
    languagemeta,
    setActiveLanguageDetails,
    isAddVerseToastOpen,
    setAddVerseToastOpen,
    handleSearch,
    searchTxt,
    isSearching,
    searchResults,
    setSearchTxt,
    setForceEditorUpdate,
    fullscreenImage,
    setFullscreenImage,
    fullscreenVideo,
    setFullscreenVideo,
    getAudioDuration,
    handleJournalModalClose,
    setJournalStats,
    setLanguagemeta,
    setJournalValues,
    setCurrJournalValues
  } = JournalsHookNew(setLoading, journalId, setJournalId,rowData);


  const [showModal, setShowModal] = useState(false);
  const [isImage, setIsImage] = useState(false);
  const [currentUrl, setCurrentUrl] = useState("");
  const dispatch=useDispatch();
const getJournalDetails = (id) => {
    setLoading(true);
    dispatch(
      readJournalAction({
        apiPayloadRequest: { _id: id },
        callback: (res) => {
                      if (res.type === 1) {
            const data = res?.data[0];
            setJournalStats({
              totalLikes: data?.totallikes ?? 0,
              totalViews: data?.curriculum_views ?? 0,
            });
            setLanguagemeta(data?.languagemetas);
            const updatedData = {
              ...data,
              notes: (data?.notes ?? [])?.filter((d) => !d?.expiryDate),
            };
            setJournalValues(updatedData);
            setCurrJournalValues(updatedData);
          }
          setLoading(false);
        },
      }),
    );
  };

  useEffect(() => {
        if (rowData?._id) {
        getJournalDetails(rowData._id);
    } else {
          }
  }, [rowData]);
  return (
    <div className="flex h-full w-full flex-1 overflow-hidden rounded-2xl">
      <div className="flex h-full flex-1">
        <LanguageDrawer
          languageData={readLanguageData}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          languagemeta={languagemeta}
          setIsLanguageSave={setIsLanguageSave}
          setActiveLanguageDetails={setActiveLanguageDetails}
        />
        {activeTab !== "en" && !journalId ? (
          <div className="flex w-full justify-center gap-1 bg-greyishV2 py-60 text-white">
            Journal translation in{" "}
            <span className="italic">
              {activeLanguageDetails?.language_name}
            </span>{" "}
            is available for saved jorunal only.
          </div>
        ) : (
          <div className="flex h-full flex-1">
            <div className="row-span-1 flex h-full w-full flex-col border-greyish border-opacity-30 bg-greyishV2 bg-opacity-50 md:border-l md:border-r">
              <div className="flex items-center justify-end py-3">
                {activeTab === "en" &&
                //   !isLoading &&
                  !journalValues?.journal_title && (
                    <button
                      className="mx-1.5 inline-flex items-center rounded-xl border border-yellowish bg-blackishV2 px-6 py-3 text-[12px] font-medium text-yellowish"
                      onClick={() => {
                        setShowJournalBox(true);
                      }}
                    >
                      <BsPlus className="text-lg" /> Add Journal Details
                    </button>
                  )}

                {!showNotesBox && activeTab === "en" && journalId && (
                  <button
                    className="mx-1.5 inline-flex items-center rounded-xl border border-yellowish bg-blackishV2 px-6 py-3 text-[12px] font-medium text-yellowish"
                    onClick={() => {
                      setCurrNotesIndex(journalValues?.notes?.length ?? 0);
                      setShowNotesBox((prev) => !prev);
                      addNewNotes();
                      setCurrNotes(initialNotesState);
                      setIsNotesEdit(false);
                    }}
                  >
                    <BsPlus className="text-lg" /> Add Notes
                  </button>
                )}
                {journalId && (
                  <button
                    className={`mx-1.5 w-fit rounded-xl border px-12 py-3 text-[12px] font-medium text-black ${
                      journalValues?.publish !== "true" && journalId
                        ? "border-yellowish bg-yellowish hover:border-yellowish hover:bg-yellowish"
                        : "border-yellowish/40 bg-yellowish/40"
                    }`}
                    {...(journalValues?.publish !== "true" && journalId
                      ? {}
                      : {
                          "data-tooltip-id": "publish_journal",
                          "data-tooltip-content": `${
                            journalValues?.publish === "true"
                              ? "Update"
                              : "Complete"
                          } Journal to publish`,
                          disabled: true,
                        })}
                    onClick={() => {
                      if (
                        journalValues?.journal_title &&
                        journalValues?.journal_description &&
                        journalValues?.bg_Images?.[0]?.url_link &&
                        journalValues?.bg_Images?.[1]?.url_link &&
                        journalValues?.bg_Images?.[2]?.url_link &&
                        journalValues?.banner_Images?.[0]?.url_link &&
                        journalValues?.banner_Images?.[1]?.url_link &&
                        journalValues?.banner_Images?.[2]?.url_link
                      ) {
                        handlePublishJournal();
                      }
                    }}
                  >
                    {journalPublishLoading ? (
                      <LoaderSpinner className="!text-black" />
                    ) : !journalValues?.publish ? (
                      "Publish Journal"
                    ) : (
                      "Update Publish"
                    )}
                  </button>
                )}

                <Tooltip
                  id="publish_journal"
                  className="border border-greyish border-opacity-20"
                />
              </div>
              {activeTab !== "en" && !journalId ? (
                <div className="flex items-center justify-center gap-1 py-28 text-white">
                  Journals translation in{" "}
                  <span className="italic">
                    {activeLanguageDetails?.language_name}
                  </span>{" "}
                  is available for saved journals
                </div>
              ) : (
                <div className="flex flex-col overflow-auto pl-12 pr-4 pt-8">
                  <div className="relative flex flex-1 flex-col gap-6 pb-8">
                    {journalId && (
                      <div className="relative flex flex-col gap-2">
                        <p className="font-white flex items-center text-2xl font-medium text-white">
                          {journalValues?.journal_title}{" "}
                          <button
                            className="ml-4 h-fit rounded-md border border-yellow-500 px-3 text-[10px] text-yellow-500"
                            onClick={() => {
                              setShowJournalBox(true);
                            }}
                          >
                            Edit
                          </button>
                        </p>
                        {activeSpeakerDetails?.speakerDisplayName && (
                          <p className="text-lg text-white/80">
                            Speaker:{" "}
                            <span className="font-semibold">
                              {activeSpeakerDetails?.speakerDisplayName}
                            </span>
                          </p>
                        )}
                        {activeCategoryDetails?.categoryname && (
                          <p className="text-lg text-white/80">
                            Category:{" "}
                            <span className="font-semibold">
                              {activeCategoryDetails?.categoryname}
                            </span>
                          </p>
                        )}
                        <div className="font-medium text-greyish">
                          {journalValues?.journal_description}
                          <div className="absolute -left-8 top-0 h-5 w-5 rounded-full bg-yellowish"></div>
                        </div>

                        {activeTab === "en" && (
                          <>
                            <div className="grid grid-cols-3 justify-between gap-2">
                              {journalValues?.bg_Images?.[0]?.url_link && (
                                <div className="flex flex-col gap-0.5">
                                  <img
                                    className="aspect-[16/9] rounded-md object-cover object-top"
                                    src={
                                      journalValues?.bg_Images?.[0]?.url_link
                                    }
                                    alt=""
                                  />
                                  <p className="text-sm text-white/50">
                                    Background Mobile Preview
                                  </p>
                                </div>
                              )}
                              {journalValues?.bg_Images?.[1]?.url_link && (
                                <div className="flex flex-col gap-0.5">
                                  <img
                                    className="aspect-[16/9] rounded-md object-cover object-top"
                                    src={
                                      journalValues?.bg_Images?.[1]?.url_link
                                    }
                                    alt=""
                                  />
                                  <p className="text-sm text-white/50">
                                    Background Web Preview
                                  </p>
                                </div>
                              )}
                              {journalValues?.bg_Images?.[2]?.url_link && (
                                <div className="flex flex-col gap-0.5">
                                  <img
                                    className="aspect-[16/9] rounded-md object-cover object-top"
                                    src={
                                      journalValues?.bg_Images?.[2]?.url_link
                                    }
                                    alt=""
                                  />
                                  <p className="text-sm text-white/50">
                                    Background Tablet Preview
                                  </p>
                                </div>
                              )}
                            </div>
                            <div className="grid grid-cols-3 justify-between gap-2">
                              {journalValues?.banner_Images?.[0]?.url_link && (
                                <div className="flex flex-col gap-0.5">
                                  <img
                                    className="aspect-[16/9] rounded-md object-cover object-top"
                                    src={
                                      journalValues?.banner_Images?.[0]
                                        ?.url_link
                                    }
                                    alt=""
                                  />
                                  <p className="text-sm text-white/50">
                                    Banner Mobile Preview
                                  </p>
                                </div>
                              )}
                              {journalValues?.banner_Images?.[1]?.url_link && (
                                <div className="flex flex-col gap-0.5">
                                  <img
                                    className="aspect-[16/9] rounded-md object-cover object-top"
                                    src={
                                      journalValues?.banner_Images?.[1]
                                        ?.url_link
                                    }
                                    alt=""
                                  />
                                  <p className="text-sm text-white/50">
                                    Banner Web Preview
                                  </p>
                                </div>
                              )}
                              {journalValues?.banner_Images?.[2]?.url_link && (
                                <div className="flex flex-col gap-0.5">
                                  <img
                                    className="aspect-[16/9] rounded-md object-cover object-top"
                                    src={
                                      journalValues?.banner_Images?.[2]
                                        ?.url_link
                                    }
                                    alt=""
                                  />
                                  <p className="text-sm text-white/50">
                                    Banner Tablet Preview
                                  </p>
                                </div>
                              )}
                            </div>
                          </>
                        )}
                      </div>
                    )}
                    {journalValues?.notes?.map((note, index) => (
                      <NotePreviewCard
                        note={note}
                        key={index}
                        journalValues={journalValues}
                        index={index}
                        setCurrNotesIndex={setCurrNotesIndex}
                        setIsNotesEdit={setIsNotesEdit}
                        setCurrNotes={setCurrNotes}
                        setShowNotesBox={setShowNotesBox}
                        handleDeleteNotes={handleDeleteNotes}
                      />
                    ))}

                    {(journalValues?.curriculum_name ||
                      journalValues?.curriculum_description) && (
                      <div className="absolute -left-6 top-0 h-full w-[1px] border border-dotted border-yellowish border-opacity-40"></div>
                    )}
                  </div>
                  <Modal
                    isOpen={showJournalBox}
                    onRequestClose={cancelJournal}
                    contentLabel="Custom Modal"
                    className="custom-modal absolute z-[40] flex h-screen w-screen items-center justify-center bg-black bg-opacity-50 py-6"
                    ariaHideApp={false}
                  >
                    <div className="MODAL-BODY h-[95vh] w-[90%] rounded-2xl bg-blackishV2 p-4 md:absolute md:w-[50%]">
                      <div className="flex h-full w-full flex-col">
                        <div className="mb-2 flex items-center justify-between">
                          <p className="text-lg font-semibold text-white">
                            Edit Journal
                          </p>
                          <div className="flex">
                            {activeTab !== "en" && (
                              <button
                                className="mr-3 flex items-center gap-1 text-[11px] font-medium text-greyish"
                                onClick={updateJournalsWithTranslation}
                              >
                                <span>
                                  {" "}
                                  <img src={reload} alt="" />{" "}
                                </span>
                                Auto fill data with google translation
                              </button>
                            )}
                            <div className="flex space-x-2">
                              <img
                                className="cursor-pointer"
                                onClick={cancelJournal}
                                src={close}
                                alt=""
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row-span-1 flex w-full flex-1 flex-col overflow-y-auto border-greyish border-opacity-30 bg-greyishV2 bg-opacity-80 md:border-l md:border-r">
                          {/* TAB CONTENT  */}

                          <div className="overflow-y-auto overflow-x-hidden p-4">
                            <div className="mx-1 grid w-full grid-cols-1 grid-rows-1 gap-x-4 gap-y-4 md:grid-cols-2">
                            {userInfo?.roleCode === "17dwer8"  &&
                  <div className="md:col-span-2 col-span-1 relative">
                  <label className="text-[12px] text-greyish font-medium leading-4 flex items-center gap-2">
                    Select Church *
                  </label>

                  <div className="relative">
                    <select
                      name="churchObjId"
                      onChange={handleChangeId}
                      className="appearance-none bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10 pr-10 focus:outline-none focus:ring-0"
                    >
                      {userInfo?.roleCode === "17dwer8" ? (
                        <>
                          <option>Select church</option>
                          <option value={userInfo?._id}>Your Church</option>
                        </>
                      ) : (
                        <>
                          <option value="">Select Church</option>
                          {churches?.data && churches.data.length > 0 ? (
                            churches.data.map((church) => (
                              <option key={church._id} value={church._id}>
                                {church.churchName}
                              </option>
                            ))
                          ) : (
                            <option disabled>No churches available</option>
                          )}
                        </>
                      )}
                    </select>

                    {/* Custom arrow */}
                    <div className="pointer-events-none absolute top-1/2 right-3 transform -translate-y-1/2 text-white">
                      <svg
                        className="w-4 h-4"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                      </svg>
                    </div>
                  </div>

                  {journalsErrors?.church_id && (
                    <p className="text-red-500 relative bottom-[-6px] text-[10px] left-2">
                      Church selection is required
                    </p>
                  )}
                </div>

}
                              <div className="col-span-1 md:col-span-2">
                                <label
                                  htmlFor="categoryName"
                                  className="flex items-center gap-2 text-[12px] font-medium leading-4 text-greyish"
                                >
                                  Journal Title *
                                  <FaInfoCircle
                                    data-tooltip-id="add_journal"
                                    data-tooltip-content="Enter the Journal Title"
                                  />
                                </label>
                                <input
                                  name="journal_title"
                                  type="text"
                                  className={`mt-2 h-10 w-full rounded-md bg-blackish p-2 text-[14px] font-medium leading-4 text-white placeholder:text-greyish`}
                                  value={journalValues?.journal_title}
                                  placeholder="Enter Journal Title"
                                  onChange={(e) => handleChange(e, "journal")}
                                />
                                {showJournalsErrors &&
                                  journalsErrors?.journal_title && (
                                    <p className="relative bottom-[-6px] left-2 text-[10px] text-red-500">
                                      Journal Title Is Required Field
                                    </p>
                                  )}
                              </div>
                              <div className="col-span-1 md:col-span-2">
                                <label
                                  htmlFor="journal"
                                  className="flex items-center gap-2 text-[12px] font-medium leading-4 text-greyish"
                                >
                                  Journal Description *
                                  <FaInfoCircle
                                    data-tooltip-id="add_journal"
                                    data-tooltip-content="Enter the Journal Description"
                                  />
                                </label>
                                <input
                                  name="journal_description"
                                  type="text"
                                  className={`mt-2 h-10 w-full rounded-md bg-blackish p-2 text-[14px] font-medium leading-4 text-white placeholder:text-greyish`}
                                  value={journalValues?.journal_description}
                                  placeholder="Enter Journal Description"
                                  onChange={(e) => handleChange(e, "journal")}
                                />
                                {showJournalsErrors &&
                                  journalsErrors?.journal_description && (
                                    <p className="relative bottom-[-6px] left-2 text-[10px] text-red-500">
                                      Journal Description Is Required Field
                                    </p>
                                  )}
                              </div>
                              {activeTab === "en" && (
                                <>
                                  <div className="col-span-1 md:col-span-2">
                                    <label
                                      htmlFor="journal"
                                      className="flex items-center gap-2 text-[12px] font-medium leading-4 text-greyish"
                                    >
                                      Journal Speaker *
                                      <FaInfoCircle
                                        data-tooltip-id="add_journal"
                                        data-tooltip-content="Enter the Journal Speaker"
                                      />
                                    </label>
                                    <select
                                      name="speakerObjId"
                                      type="text"
                                      className={`mt-2 h-10 w-full rounded-md bg-blackish p-2 text-[14px] font-medium leading-4 text-white placeholder:text-greyish`}
                                      value={journalValues?.speakerObjId}
                                      placeholder="Enter Journal Speaker"
                                      onChange={(e) =>
                                        handleChange(e, "journal")
                                      }
                                    >
                                      <option value="">Select Speaker</option>
                                      {speakers?.map((item, index) => (
                                        <option
                                          key={`speaker-item${index}`}
                                          value={item?._id}
                                        >
                                          {item?.speakerDisplayName}
                                        </option>
                                      ))}
                                    </select>

                                    {showJournalsErrors &&
                                      journalsErrors?.speakerObjId && (
                                        <p className="relative bottom-[-6px] left-2 text-[10px] text-red-500">
                                          Journal Speaker Is Required Field
                                        </p>
                                      )}
                                  </div>
                                  <div className="col-span-1 mb-3 md:col-span-2">
                                    <label
                                      htmlFor="journal"
                                      className="flex items-center gap-2 text-[12px] font-medium leading-4 text-greyish"
                                    >
                                      Journal Category *
                                      <FaInfoCircle
                                        data-tooltip-id="add_journal"
                                        data-tooltip-content="Enter the Journal Category"
                                      />
                                    </label>
                                    <select
                                      name="categoryObjId"
                                      type="text"
                                      className={`mt-2 h-10 w-full rounded-md bg-blackish p-2 text-[14px] font-medium leading-4 text-white placeholder:text-greyish`}
                                      value={journalValues?.categoryObjId}
                                      placeholder="Enter Journal Category"
                                      onChange={(e) =>
                                        handleChange(e, "journal")
                                      }
                                    >
                                      <option value="">Select Category</option>
                                      {journalCategoriesList?.map(
                                        (item, index) => (
                                          <option
                                            key={`speaker-item${index}`}
                                            value={item?._id}
                                          >
                                            {item?.categoryname}
                                          </option>
                                        ),
                                      )}
                                    </select>

                                    {showJournalsErrors &&
                                      journalsErrors?.categoryObjId && (
                                        <p className="relative bottom-[-6px] left-2 text-[10px] text-red-500">
                                          Journal Category Is Required Field
                                        </p>
                                      )}
                                  </div>
                                </>
                              )}
                            </div>

                            {activeTab === "en" && (
                              <>
                                <UploadControlsV2
                                  tooltipTitle="Upload Background Image"
                                  className="col-span-2 my-2"
                                  defaultCollapse={false}
                                  title="Background *"
                                  subtitle="Upload Image"
                                  mobileUploadName="bg_Images"
                                  handleMobileChangeUrl={(e) =>
                                    handleChange(e, "journal", 0)
                                  }
                                  mobileUploadProgressId="mobileUploadUrlAddJournalBackground"
                                  handleMobileFileUpload={(e) =>
                                    handleChange(
                                      e,
                                      "journalFile",
                                      0,
                                      null,
                                      null,
                                      "mobileUploadUrlAddJournalBackground",
                                    )
                                  }
                                  mobileUploadUrl={
                                    journalValues?.bg_Images?.[0]?.url_link
                                  }
                                  handleMobilePreview={() => {
                                    setIsImage(true);
                                    setShowModal(true);
                                    setCurrentUrl(
                                      journalValues?.bg_Images?.[0]?.url_link,
                                    );
                                  }}
                                  mobileUploadCropRequired={true}
                                  mobileUploadCropAspect={3 / 4}
                                  isMobileFieldRequired={
                                    showJournalsErrors &&
                                    journalsErrors?.bg_Images?.[0]?.url_link
                                  }
                                  tabletUploadName="bg_Images"
                                  handleTabletChangeUrl={(e) =>
                                    handleChange(e, "journal", 2)
                                  }
                                  tabletUploadProgressId="tabletUploadUrlAddJournalBackground"
                                  handleTabletFileUpload={(e) =>
                                    handleChange(
                                      e,
                                      "journalFile",
                                      2,
                                      null,
                                      null,
                                      "tabletUploadUrlAddJournalBackground",
                                    )
                                  }
                                  tabletUploadUrl={
                                    journalValues?.bg_Images?.[2]?.url_link
                                  }
                                  handleTabletPreview={() => {
                                    setIsImage(true);
                                    setShowModal(true);
                                    setCurrentUrl(
                                      journalValues?.bg_Images?.[2]?.url_link,
                                    );
                                  }}
                                  tabletUploadCropRequired={true}
                                  tabletUploadCropAspect={16 / 9}
                                  isTabletFieldRequired={
                                    showJournalsErrors &&
                                    journalsErrors?.bg_Images?.[2]?.url_link
                                  }
                                  webUploadName="bg_Images"
                                  handleWebChangeUrl={(e) =>
                                    handleChange(e, "journal", 1)
                                  }
                                  webUploadProgressId="webUploadUrlAddJournalBackground"
                                  handleWebFileUpload={(e) =>
                                    handleChange(
                                      e,
                                      "journalFile",
                                      1,
                                      null,
                                      null,
                                      "webUploadUrlAddJournalBackground",
                                    )
                                  }
                                  webUploadUrl={
                                    journalValues?.bg_Images?.[1]?.url_link
                                  }
                                  handleWebPreview={() => {
                                    setIsImage(true);
                                    setShowModal(true);
                                    setCurrentUrl(
                                      journalValues?.bg_Images?.[1]?.url_link,
                                    );
                                  }}
                                  webUploadCropRequired={true}
                                  webUploadCropAspect={16 / 9}
                                  isWebFieldRequired={
                                    showJournalsErrors &&
                                    journalsErrors?.bg_Images?.[1]?.url_link
                                  }
                                  requiredMessage="Please Upload the Image URL"
                                />
                                <UploadControlsV2
                                  tooltipTitle="Upload Banner Image"
                                  className="col-span-2 my-2"
                                  defaultCollapse={false}
                                  title="Banner *"
                                  subtitle="Upload Image"
                                  mobileUploadName="banner_Images"
                                  handleMobileChangeUrl={(e) =>
                                    handleChange(e, "journal", 0)
                                  }
                                  mobileUploadProgressId="mobileUploadUrlAddJournalBanner"
                                  handleMobileFileUpload={(e) =>
                                    handleChange(
                                      e,
                                      "journalFile",
                                      0,
                                      null,
                                      null,
                                      "mobileUploadUrlAddJournalBanner",
                                    )
                                  }
                                  mobileUploadUrl={
                                    journalValues?.banner_Images?.[0]?.url_link
                                  }
                                  handleMobilePreview={() => {
                                    setIsImage(true);
                                    setShowModal(true);
                                    setCurrentUrl(
                                      journalValues?.banner_Images?.[0]
                                        ?.url_link,
                                    );
                                  }}
                                  mobileUploadCropRequired={true}
                                  mobileUploadCropAspect={3 / 4}
                                  isMobileFieldRequired={
                                    showJournalsErrors &&
                                    journalsErrors?.banner_Images?.[0]?.url_link
                                  }
                                  tabletUploadName="banner_Images"
                                  handleTabletChangeUrl={(e) =>
                                    handleChange(e, "journal", 2)
                                  }
                                  tabletUploadProgressId="tabletUploadUrlAddJournalBanner"
                                  handleTabletFileUpload={(e) =>
                                    handleChange(
                                      e,
                                      "journalFile",
                                      2,
                                      null,
                                      null,
                                      "tabletUploadUrlAddJournalBanner",
                                    )
                                  }
                                  tabletUploadUrl={
                                    journalValues?.banner_Images?.[2]?.url_link
                                  }
                                  handleTabletPreview={() => {
                                    setIsImage(true);
                                    setShowModal(true);
                                    setCurrentUrl(
                                      journalValues?.banner_Images?.[2]
                                        ?.url_link,
                                    );
                                  }}
                                  tabletUploadCropRequired={true}
                                  tabletUploadCropAspect={16 / 9}
                                  isTabletFieldRequired={
                                    showJournalsErrors &&
                                    journalsErrors?.banner_Images?.[2]?.url_link
                                  }
                                  webUploadName="banner_Images"
                                  handleWebChangeUrl={(e) =>
                                    handleChange(e, "journal", 1)
                                  }
                                  webUploadProgressId="webUploadUrlAddJournalBanner"
                                  handleWebFileUpload={(e) =>
                                    handleChange(
                                      e,
                                      "journalFile",
                                      1,
                                      null,
                                      null,
                                      "webUploadUrlAddJournalBanner",
                                    )
                                  }
                                  webUploadUrl={
                                    journalValues?.banner_Images?.[1]?.url_link
                                  }
                                  handleWebPreview={() => {
                                    setIsImage(true);
                                    setShowModal(true);
                                    setCurrentUrl(
                                      journalValues?.banner_Images?.[1]
                                        ?.url_link,
                                    );
                                  }}
                                  webUploadCropRequired={true}
                                  webUploadCropAspect={16 / 9}
                                  isWebFieldRequired={
                                    showJournalsErrors &&
                                    journalsErrors?.banner_Images?.[1]?.url_link
                                  }
                                  requiredMessage="Please Upload the Image URL"
                                />
                              </>
                            )}
                          </div>
                        </div>
                        <div className="flex w-full justify-end gap-5 pt-5">
                          <button
                            className="rounded-xl border border-yellowish bg-blackish px-6 py-2 text-[12px] font-medium text-yellowish"
                            onClick={handleJournalModalClose}
                          >
                            Close
                          </button>
                          <button
                            className="rounded-xl border border-yellowish bg-blackish px-6 py-2 text-[12px] font-medium text-yellowish"
                            onClick={() => {
                              if (
                                activeTab === "en" &&
                                (journalsErrors?.journal_title ||
                                  journalsErrors?.journal_description ||
                                  journalsErrors?.bg_Images?.[0].url_link ||
                                  journalsErrors?.bg_Images?.[1].url_link ||
                                  journalsErrors?.bg_Images?.[2].url_link ||
                                  journalsErrors?.banner_Images?.[0].url_link ||
                                  journalsErrors?.banner_Images?.[1].url_link ||
                                  journalsErrors?.banner_Images?.[2].url_link ||
                                  journalsErrors?.banner_Images?.[2]
                                    .speakerObjId)
                              ) {
                                setShowJournalsErrors(true);
                              } else if (activeTab !== "en") {
                                saveJournalsLanguage();
                              } else {
                                saveJournals({hideUI,onClose,reloadData,setReloadData,church});
                              }
                            }}
                          >
                            {journalId
                              ? "Update Journal"
                              : "Save Journal Draft"}
                          </button>
                        </div>
                      </div>
                      <Tooltip
                        id="add_journal"
                        className="border border-greyish border-opacity-20"
                      />
                    </div>
                  </Modal>
                  <Modal
                    isOpen={showNotesBox}
                    onRequestClose={() => {
                      setShowNotesBox((prev) => !prev);
                      cancelNotes(
                        journalValues?.notes?.[currNotesIndex],
                        currNotesIndex,
                      );
                    }}
                    contentLabel="Custom Modal"
                    className="custom-modal absolute z-[40] flex h-screen w-screen items-center justify-center bg-black bg-opacity-50 py-6"
                    ariaHideApp={false}
                  >
                    <div className="MODAL-BODY h-[95%] w-[90%] rounded-2xl bg-greyishV2 p-5 md:absolute md:w-[40%]">
                      <div className="flex h-full w-full flex-col">
                        <div className="mb-4 flex items-center justify-between">
                          <div className="flex items-center gap-1 text-lg font-semibold text-yellowish">
                            <IoIosArrowBack
                              className="cursor-pointer text-2xl"
                              onClick={() => setShowNotesBox(false)}
                            />
                            Add Notes
                            {currNotes?.noteObjId && (
                              <RiDeleteBin5Line
                                className="ml-5 cursor-pointer text-xl text-red-500"
                                onClick={() =>
                                  handleDeleteNotes({
                                    noteObjId: currNotes?.noteObjId,
                                    notesIndex: currNotesIndex,
                                  })
                                }
                              />
                            )}
                          </div>
                          <div className="flex">
                            <div className="flex space-x-2">
                              {activeTab !== "en" && (
                                <button
                                  className="mr-3 flex items-center gap-1 text-[11px] font-medium text-greyish"
                                  onClick={updateNotesWithTranslation}
                                >
                                  <span>
                                    {" "}
                                    <img src={reload} alt="" />{" "}
                                  </span>
                                  Auto fill data with google translation
                                </button>
                              )}

                              <IoClose
                                className="cursor-pointer text-2xl text-yellowish"
                                onClick={() => setShowNotesBox(false)}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="flex flex-1 flex-col overflow-hidden rounded-3xl rounded-ss-none border border-yellowish pb-7 pt-3">
                          <div className="custom-scrollbar flex flex-1 flex-col overflow-y-auto pb-3 pl-5 pr-8">
                            {currNotes?.lastUpdatedDate && (
                              <p className="mb-3 text-xs font-semibold text-greyish">
                                {format(
                                  currNotes?.lastUpdatedDate,
                                  "dd MMM yyyy",
                                )}
                              </p>
                            )}
                            <ul className="flex flex-col gap-3">
                              {currNotes?.noteitems?.map((item, index) => (
                                <li key={`curr-note-item${index}`}>
                                  {item?.type_of_notes ===
                                    JOURNAL_NOTE_ITEM_TYPES.VIDEO &&
                                    !item?.isMulti && (
                                      <div
                                        className="relative w-full py-3 text-greyish"
                                        key={`note-item${index}`}
                                      >
                                        {item?.isLoading ? (
                                          <LoaderSpinner />
                                        ) : item?.thumbnail ? (
                                          <div
                                            className="flex cursor-pointer items-center"
                                            onClick={() =>
                                              setFullscreenVideo(item?.url_link)
                                            }
                                          >
                                            <div className="relative max-h-[75vh] w-8/12">
                                              <img
                                                src={item.thumbnail}
                                                alt={
                                                  "video-thumbnail-" +
                                                  (index + 1)
                                                }
                                                className="h-full w-full rounded object-contain"
                                              />
                                              <span className="absolute left-0 top-0 flex h-full w-full items-center justify-center">
                                                <svg
                                                  width="64"
                                                  height="64"
                                                  viewBox="0 0 64 64"
                                                >
                                                  <circle
                                                    cx="32"
                                                    cy="32"
                                                    r="32"
                                                    fill="rgba(0,0,0,0.5)"
                                                  />
                                                  <polygon
                                                    points="26,20 48,32 26,44"
                                                    fill="#fff"
                                                  />
                                                </svg>
                                              </span>
                                            </div>
                                          </div>
                                        ) : (
                                          item?.url_link && (
                                            <div
                                              className="relative max-h-[75vh] w-8/12 cursor-pointer"
                                              onClick={() =>
                                                setFullscreenVideo(
                                                  item?.url_link,
                                                )
                                              }
                                            >
                                              <video
                                                src={item?.url_link}
                                                alt={"video" + (index + 1)}
                                                className="bg-greyishV3 max-w-full border border-greyishV2 object-contain"
                                                controls={false}
                                              />
                                              <span className="absolute left-0 top-0 flex h-full w-full items-center justify-center">
                                                <svg
                                                  width="64"
                                                  height="64"
                                                  viewBox="0 0 64 64"
                                                >
                                                  <circle
                                                    cx="32"
                                                    cy="32"
                                                    r="32"
                                                    fill="rgba(0,0,0,0.5)"
                                                  />
                                                  <polygon
                                                    points="26,20 48,32 26,44"
                                                    fill="#fff"
                                                  />
                                                </svg>
                                              </span>
                                            </div>
                                          )
                                        )}
                                        {item?.notes && (
                                          <MyStatefulEditor
                                            forceEditorUpdate={
                                              forceEditorUpdate
                                            }
                                            labelColor="white"
                                            labelText=""
                                            darkMode={true}
                                            placeholder="| What's God speaking to you?"
                                            htmlFor="currNotesText"
                                            name="currNotesText"
                                            value={item?.notes}
                                            handleInputChange={(e) => {
                                              setCurrNotes((prev) => {
                                                const updatedData =
                                                  structuredClone(prev);
                                                updatedData.noteitems[
                                                  index
                                                ].notes = e.target.value;
                                                return updatedData;
                                              });
                                            }}
                                            largeToolbar={true}
                                            showToolbarOnFocus={true}
                                          />
                                        )}
                                        {item?.isLoading && <LoaderSpinner />}
                                        <button className="absolute -right-5 top-1/2 w-fit -translate-y-1/2">
                                          <FaMinusCircle
                                            onClick={() =>
                                              deleteNoteItem(index)
                                            }
                                            className="cursor-pointer text-red-600"
                                          />
                                        </button>
                                      </div>
                                    )}
                                  {item?.type_of_notes ===
                                    JOURNAL_NOTE_ITEM_TYPES.VIDEO &&
                                    item?.isMulti && (
                                      <div className="group relative grid w-full grid-cols-2 gap-3">
                                        {item?.isLoading ? (
                                          <div className="aspect-video w-5/12 animate-pulse overflow-hidden rounded-md bg-zinc-600 object-cover"></div>
                                        ) : (
                                          item?.url_link?.map(
                                            (url, urlIndex) => (
                                              <video
                                                key={`url-item${urlIndex}${index}`}
                                                src={url}
                                                className="aspect-video overflow-hidden rounded-md object-cover"
                                                controls={true}
                                              ></video>
                                            ),
                                          )
                                        )}
                                        <button className="absolute -right-5 top-1/2 w-fit -translate-y-1/2">
                                          <FaMinusCircle
                                            onClick={() =>
                                              deleteNoteItem(index)
                                            }
                                            className="cursor-pointer text-red-600"
                                          />
                                        </button>
                                      </div>
                                    )}
                                  {item?.type_of_notes ===
                                    JOURNAL_NOTE_ITEM_TYPES.IMAGE &&
                                    !item?.isMulti && (
                                      <div
                                        className="relative w-full py-3 text-greyish"
                                        key={`note-item${index}`}
                                      >
                                        {item?.isLoading ? (
                                          <LoaderSpinner />
                                        ) : (
                                          item?.url_link && (
                                            <>
                                              <img
                                                src={item?.url_link}
                                                alt={"image" + (index + 1)}
                                                className="col-span-3 max-h-[75vh] max-w-full cursor-pointer object-contain"
                                                onClick={() =>
                                                  setFullscreenImage(
                                                    item?.url_link,
                                                  )
                                                }
                                              />
                                              {item?.notes && (
                                                <MyStatefulEditor
                                                  forceEditorUpdate={
                                                    forceEditorUpdate
                                                  }
                                                  labelColor="white"
                                                  labelText=""
                                                  darkMode={true}
                                                  placeholder="| What's God speaking to you?"
                                                  htmlFor="currNotesText"
                                                  name="currNotesText"
                                                  value={item?.notes}
                                                  handleInputChange={(e) => {
                                                    setCurrNotes((prev) => {
                                                      const updatedData =
                                                        structuredClone(prev);
                                                      updatedData.noteitems[
                                                        index
                                                      ].notes = e.target.value;
                                                      return updatedData;
                                                    });
                                                  }}
                                                  largeToolbar={true}
                                                  showToolbarOnFocus={true}
                                                />
                                              )}
                                            </>
                                          )
                                        )}
                                        <button className="absolute -right-5 top-1/2 w-fit -translate-y-1/2">
                                          <FaMinusCircle
                                            onClick={() =>
                                              deleteNoteItem(index)
                                            }
                                            className="cursor-pointer text-red-600"
                                          />
                                        </button>
                                      </div>
                                    )}
                                  {item?.type_of_notes ===
                                    JOURNAL_NOTE_ITEM_TYPES.IMAGE &&
                                    item?.isMulti && (
                                      <div className="group relative grid w-full grid-cols-2 gap-3 overflow-hidden">
                                        {item?.isLoading ? (
                                          <div className="aspect-video w-5/12 animate-pulse overflow-hidden rounded-md bg-zinc-600 object-cover"></div>
                                        ) : (
                                          item?.url_link?.map(
                                            (url, urlIndex) => (
                                              <img
                                                key={`url-item${urlIndex}${index}`}
                                                src={url}
                                                className="aspect-video overflow-hidden rounded-md object-cover"
                                                controls={true}
                                                alt=""
                                              />
                                            ),
                                          )
                                        )}
                                        <button className="absolute -right-5 top-1/2 w-fit -translate-y-1/2">
                                          <FaMinusCircle
                                            onClick={() =>
                                              deleteNoteItem(index)
                                            }
                                            className="cursor-pointer text-red-600"
                                          />
                                        </button>
                                      </div>
                                    )}
                                  {item?.type_of_notes ===
                                    JOURNAL_NOTE_ITEM_TYPES.TEXT && (
                                    <div className="group relative">
                                      <MyStatefulEditor
                                        forceEditorUpdate={forceEditorUpdate}
                                        labelColor="white"
                                        labelText=""
                                        darkMode={true}
                                        placeholder="| What's God speaking to you?"
                                        htmlFor="currNotesText"
                                        name="currNotesText"
                                        value={item?.notes}
                                        handleInputChange={(e) => {
                                          setCurrNotes((prev) => ({
                                            ...prev,
                                            noteitems: prev.noteitems.map(
                                              (item, i) =>
                                                i === index
                                                  ? {
                                                      ...item,
                                                      notes: e.target.value,
                                                    }
                                                  : item,
                                            ),
                                          }));
                                        }}
                                        minimalToolbar={true}
                                        showToolbarOnFocus={true}
                                      />
                                      <button className="absolute -right-5 top-1/2 w-fit -translate-y-1/2">
                                        <FaMinusCircle
                                          onClick={() => deleteNoteItem(index)}
                                          className="cursor-pointer text-red-600"
                                        />
                                      </button>
                                    </div>
                                  )}
                                  {item?.type_of_notes ===
                                    JOURNAL_NOTE_ITEM_TYPES.AUDIO &&
                                    !item?.isMulti && (
                                      <div className="relative">
                                        <AudioCard
                                          url={item?.url_link}
                                          duration={item?.duration}
                                        />
                                        <button className="absolute -right-5 top-1/2 w-fit -translate-y-1/2">
                                          <FaMinusCircle
                                            onClick={() =>
                                              deleteNoteItem(index)
                                            }
                                            className="cursor-pointer text-red-600"
                                          />
                                        </button>
                                      </div>
                                    )}
                                  {item?.type_of_notes ===
                                    JOURNAL_NOTE_ITEM_TYPES.AUDIO &&
                                    item?.isMulti && (
                                      <div className="group relative flex flex-wrap items-center gap-3">
                                        {item?.url_link?.map(
                                          (url, urlIndex) => (
                                            <AudioCard
                                              url={item?.url_link}
                                              key={`url-item${urlIndex}${index}`}
                                              duration={item?.duration}
                                            />
                                          ),
                                        )}
                                        <button className="absolute -right-5 top-1/2 w-fit -translate-y-1/2">
                                          <FaMinusCircle
                                            onClick={() =>
                                              deleteNoteItem(index)
                                            }
                                            className="cursor-pointer text-red-600"
                                          />
                                        </button>
                                      </div>
                                    )}
                                  {item?.type_of_notes ===
                                    JOURNAL_NOTE_ITEM_TYPES.VERSE && (
                                    <div className="group relative flex flex-col flex-wrap gap-3 text-white">
                                      <h3 className="text-2xl font-semibold">
                                        {item?.bookname}{" "}
                                        <span>
                                          {item?.chapterid}:{item?.verse_start}
                                        </span>
                                      </h3>
                                      <p>{item?.notes}</p>
                                      <button className="absolute -right-5 top-1/2 w-fit -translate-y-1/2">
                                        <FaMinusCircle
                                          onClick={() => deleteNoteItem(index)}
                                          className="cursor-pointer text-red-600"
                                        />
                                      </button>
                                    </div>
                                  )}
                                </li>
                              ))}
                            </ul>
                            <div className="group relative">
                              {currNotes?.text && (
                                <FiPlusCircle
                                  onClick={() => handleAddNoteText()}
                                  className="absolute -right-2 top-1/2 z-[2000] hidden -translate-y-1/2 cursor-pointer rounded-full bg-blackishV2 text-lg text-white group-hover:block"
                                />
                              )}
                              <MyStatefulEditor
                                forceEditorUpdate={forceEditorUpdate}
                                labelColor="white"
                                labelText=""
                                darkMode={true}
                                placeholder="| What's God speaking to you?"
                                htmlFor="currNotesText"
                                name="currNotesText"
                                value={currNotes?.text}
                                handleInputChange={(e) => {
                                  setCurrNotes((prev) => ({
                                    ...prev,
                                    text: e.target.value,
                                  }));
                                }}
                                minimalToolbar={true}
                                showToolbarOnFocus={true}
                              />
                            </div>
                          </div>
                          {isAddVerseToastOpen && (
                            <div className="w-full px-4">
                              <div className="w-full rounded-2xl bg-greyish/10 p-3 md:p-8">
                                <div className="flex w-full items-center gap-4 px-2 pb-5">
                                  <div className="flex w-full items-center gap-3 rounded-md bg-greyish px-3 py-1.5">
                                    <input
                                      type="text"
                                      value={searchTxt}
                                      placeholder="Search the Bible"
                                      onClick={(e) => e.stopPropagation()}
                                      onChange={(e) =>
                                        setSearchTxt(e.target.value)
                                      }
                                      onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                          handleSearch(searchTxt);
                                        }
                                      }}
                                      className="w-full bg-greyish text-blackish outline-none placeholder:text-blackish"
                                    />
                                    <button
                                      className="flex aspect-square items-center justify-center rounded-full bg-yellowish p-1"
                                      onClick={() => handleSearch(searchTxt)}
                                    >
                                      <LuSearch className="text-xl text-blackish" />
                                    </button>
                                  </div>
                                  <IoClose
                                    className="cursor-pointer text-2xl text-yellowish"
                                    onClick={() => setAddVerseToastOpen(false)}
                                  />
                                </div>
                                <ul className="custom-scrollbar flex max-h-[30vh] flex-1 flex-col gap-1 overflow-y-auto pr-2">
                                  {!isSearching &&
                                    searchResults?.map((item, index) => {
                                      return (
                                        <div
                                          key={`search-item${index}`}
                                          className="cursor-pointer rounded-md px-2 py-2 text-white hover:bg-black/30"
                                          onClick={() => {
                                            setCurrNotes((prev) => {
                                              let updatedData =
                                                structuredClone(prev);

                                              updatedData = {
                                                ...(updatedData ?? {}),
                                                text: "",
                                                noteitems: [
                                                  ...(updatedData.noteitems ??
                                                    []),
                                                  ...(currNotes?.text?.length >
                                                  0
                                                    ? [
                                                        {
                                                          type_of_notes:
                                                            JOURNAL_NOTE_ITEM_TYPES.TEXT,
                                                          notes: prev?.text,
                                                        },
                                                      ]
                                                    : []),
                                                  {
                                                    type_of_notes:
                                                      JOURNAL_NOTE_ITEM_TYPES.VERSE,
                                                    verse_start:
                                                      item?.verse_start,
                                                    verse_end: item?.verse_end,
                                                    bookname: item?.book_name,
                                                    bookid: item?.book_id,
                                                    chapterid: item?.chapter,
                                                    notes: item?.verse_text,
                                                  },
                                                ],
                                              };

                                              setForceEditorUpdate(true);
                                              setTimeout(
                                                () =>
                                                  setForceEditorUpdate(false),
                                                500,
                                              );
                                              return updatedData;
                                            });

                                            setAddVerseToastOpen(false);
                                          }}
                                        >
                                          <p className="">{item?.verse_text}</p>
                                          <div className="text-greyishV3 flex w-full items-center justify-between text-sm">
                                            <p className="">
                                              {item?.book_name}{" "}
                                              <span className="">
                                                {item?.chapter}:
                                                {item?.verse_start}
                                              </span>
                                            </p>
                                            <FaPlusCircle className="cursor-pointer" />
                                          </div>
                                        </div>
                                      );
                                    })}
                                  {isSearching && (
                                    <li className="flex cursor-pointer flex-col items-center justify-center gap-2 py-5 text-yellowish">
                                      <LoaderSpinner />
                                      <p>Loading Results..</p>
                                    </li>
                                  )}
                                  {!isSearching &&
                                    searchResults?.length === 0 && (
                                      <li className="flex cursor-pointer flex-col items-center justify-center gap-2 py-10 text-yellowish">
                                        <p>No Results Found</p>
                                      </li>
                                    )}
                                </ul>
                              </div>
                            </div>
                          )}
                          <div className="flex items-center justify-between gap-3 px-5 pt-3">
                            <div className="flex items-center gap-3">
                              <UploadVideoButton
                                showVideoLibrarySelection={true}
                                handleLibraryVideoSelection={(details) => {
                                  const item = details?.downloadurls?.find(
                                    (d) => d?.type_of_url === "1",
                                  );
                                  const thumbnail = details?.tumbnailurls?.find(
                                    (d) => d?.type_of_url === "1",
                                  );
                                  handleAddNotesAsset(
                                    currNotesIndex,
                                    JOURNAL_NOTE_ITEM_TYPES.VIDEO,
                                    null,
                                    item?.url_link,
                                    details?.video_title,
                                    thumbnail?.url_link,
                                  );
                                }}
                                handleVideoUpload={(
                                  file,
                                  caption,
                                  thumbnail,
                                ) => {
                                  handleAddNotesAsset(
                                    currNotesIndex,
                                    JOURNAL_NOTE_ITEM_TYPES.VIDEO,
                                    [file],
                                    null,
                                    caption,
                                    thumbnail,
                                  );
                                }}
                                handleVideoCapture={(
                                  file,
                                  caption,
                                  thumbnail,
                                ) => {
                                  handleAddNotesAsset(
                                    currNotesIndex,
                                    JOURNAL_NOTE_ITEM_TYPES.VIDEO,
                                    [file],
                                    null,
                                    caption,
                                    thumbnail,
                                  );
                                }}
                              />
                              <UploadAudioButton
                                handleAudioUpload={async (e) => {
                                  const duration = await getAudioDuration(
                                    e.target.files?.[0],
                                  );
                                                                    handleAddNotesAsset(
                                    currNotesIndex,
                                    JOURNAL_NOTE_ITEM_TYPES.AUDIO,
                                    e.target.files,
                                    null,
                                    null,
                                    null,
                                    duration,
                                  );
                                }}
                                handleAudioCapture={(file, duration) => {
                                  handleAddNotesAsset(
                                    currNotesIndex,
                                    JOURNAL_NOTE_ITEM_TYPES.AUDIO,
                                    [file],
                                    null,
                                    null,
                                    null,
                                    duration,
                                  );
                                }}
                              />
                              <UploadImageButton
                                handleImageUpload={(file, caption) => {
                                  handleAddNotesAsset(
                                    currNotesIndex,
                                    JOURNAL_NOTE_ITEM_TYPES.IMAGE,
                                    [file],
                                    null,
                                    caption,
                                  );
                                }}
                                handleImageCapture={(file, caption) => {
                                  handleAddNotesAsset(
                                    currNotesIndex,
                                    JOURNAL_NOTE_ITEM_TYPES.IMAGE,
                                    [file],
                                    null,
                                    caption,
                                  );
                                }}
                              />
                              <button
                                className="flex items-center gap-2 rounded-xl border border-white/30 px-4 py-2 text-sm text-white"
                                onClick={() => setAddVerseToastOpen(true)}
                              >
                                <FaPlus className="" /> Verse
                              </button>
                            </div>

                            <button
                              className="rounded-xl border border-yellowish px-8 py-2 text-yellowish hover:bg-yellowish hover:text-blackishV2"
                              onClick={() => {
                                if (activeTab === "en") {
                                  saveNotes();
                                } else {
                                  saveNotesLanguage();
                                }
                              }}
                            >
                              <FaCheck className="text-xl" />
                            </button>
                          </div>
                        </div>
                      </div>
                      <Tooltip
                        id="add_journal_notes"
                        className="border border-greyish border-opacity-20"
                      />
                    </div>
                  </Modal>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
      <CollapsibleRightPanel title="Stats" className="w-[33%] bg-[#1b1b1b]">
        <CustomTabsV2
          tabHeight={"h-[64px]"}
          tabsTitleArray={["Stats"]}
          tabsContentObject={{
            Stats: (
              <div className="mt-8 flex w-full items-center justify-center text-white">
                {journalId ? (
                  <div className="w-full px-8">
                    <p>
                      Views : <strong>{journalStats?.totalViews}</strong>
                    </p>
                    <p>
                      Likes: <strong>{journalStats?.totalLikes}</strong>
                    </p>
                  </div>
                ) : (
                  "No stats available for journal"
                )}
              </div>
            ),
          }}
        />
      </CollapsibleRightPanel>
      <ReactModal
        isOpen={showModal}
        onRequestClose={() => setShowModal(false)}
        className="relative"
        bodyOpenClassName="z-50"
      >
        <div className="relative flex h-full w-full justify-center">
          <div
            className="absolute right-0 top-0 cursor-pointer"
            onClick={() => setShowModal(false)}
          >
            <ImCross />
          </div>
          {isImage ? (
            <img className="h-[95vh] w-[95vw] object-contain" src={currentUrl} alt="" />
          ) : (
            <video className="h-[95vh] w-[95vw] object-contain" controls autoPlay>
              <source src={currentUrl} />
            </video>
          )}
        </div>
      </ReactModal>

      {/* Fullscreen Image Modal */}
      <ReactModal
        isOpen={!!fullscreenImage}
        onRequestClose={() => setFullscreenImage(null)}
        className="fixed inset-0 z-[99999] flex items-center justify-center bg-black bg-opacity-90 outline-none"
        overlayClassName="fixed inset-0 bg-black bg-opacity-90 z-[99999]"
        ariaHideApp={false}
      >
        <div className="relative flex h-full w-full items-center justify-center">
          <button
            className="absolute right-4 top-4 z-50 rounded-full bg-yellowish p-2 text-2xl text-blackish"
            onClick={() => setFullscreenImage(null)}
          >
            <IoMdClose alt="Close" />
          </button>
          <img
            src={fullscreenImage}
            alt="Fullscreen"
            className="mx-auto max-h-[90vh] max-w-[90vw] rounded-xl object-contain"
          />
        </div>
      </ReactModal>

      {/* Fullscreen Video Modal */}
      <ReactModal
        isOpen={!!fullscreenVideo}
        onRequestClose={() => setFullscreenVideo(null)}
        className="fixed inset-0 z-[99999] flex items-center justify-center bg-black bg-opacity-90 outline-none"
        overlayClassName="fixed inset-0 bg-black bg-opacity-90 z-[99999]"
        ariaHideApp={false}
      >
        <div className="relative flex h-full w-full items-center justify-center">
          <button
            className="absolute right-4 top-4 z-50 rounded-full bg-yellowish p-2 text-2xl text-blackish"
            onClick={() => setFullscreenVideo(null)}
          >
            <IoMdClose alt="Close" />
          </button>
          <video
            src={fullscreenVideo}
            controls
            autoPlay
            className="mx-auto max-h-[90vh] max-w-[90vw] rounded-xl object-contain"
          />
        </div>
      </ReactModal>
    </div>
  );
};

export default AddJournalFields;
